/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from '@angular/core';
import { RequestHistory } from '../../my-requests/commons/interfaces/my-requests.interface';
import { RequestsService } from 'src/app/home/services/requests.service';
import {
  PROGRESS_BAR_APROVE_REQUEST,
  PROGRESS_BAR_ERROR_REQUEST,
  PROGRESS_BAR_REJECT_REQUEST,
  PROGRESS_BAR_SEND_REQUEST,
  PROGRESS_BAR_CANCEL_REQUEST

} from '../../my-requests/commons/constans/my-requests.constants';

@Component({
  selector: 'app-benefit-detail',
  templateUrl: './benefit-detail.component.html',
  styleUrls: ['./benefit-detail.component.scss'],
})
export class BenefitDetailComponent {
  @Input() dataBenefit!: RequestHistory;
  @Input() idElement!: any;
  idCode!: number;
  openModal = false;

  constructor(private requestSrvc: RequestsService) {}

  cancelRequest(idCode: number) {
    this.idCode = idCode;
    this.openModal = true;
  }

  aproveRequest(idCode: number) {
    const sendData = {
      id: idCode,
      idrequest: idCode,
      parameters: {
        updatedAt: '2024-05-02',
        statusRequest: 'Aprobada',
      },
    };
    this.requestSrvc.putRequests(sendData);
  }

  closeModal(update: boolean) {
    this.openModal = update;
  }

  updateProgressSteps(status: string) {
    let newProgressBarList = [];
    switch (status) {
      case 'Aprobada':
        newProgressBarList = PROGRESS_BAR_APROVE_REQUEST;
        break;
      case 'Rechazada':
        newProgressBarList = PROGRESS_BAR_REJECT_REQUEST;
        break;
      case 'Con error':
        newProgressBarList = PROGRESS_BAR_ERROR_REQUEST;
        break;
      case 'Anulada':
        newProgressBarList = PROGRESS_BAR_CANCEL_REQUEST;
        break;
      default:
        newProgressBarList = PROGRESS_BAR_SEND_REQUEST;
        break;
    }
    return JSON.parse(JSON.stringify(newProgressBarList));
  }
}
